import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'base-layout',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      height: '100vh',
      display: 'flex',
      backgroundColor: theme.palette.background.default,
    },
    main: {
      flexGrow: 1,
    },
    header: {},
    content: {
      height: 'calc(100vh - 60px)',
    },
  }),
  options
);

export default useStyles;
